import { notification } from "antd";
import { IconType } from "antd/es/notification/interface";

function handleApiMessage(message: string, type: IconType) {
  notification.open({ message, type });
}
export default handleApiMessage;
